// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1VN7T","footer":"ModalUpdate_footer__3OWfd"};